import { FC } from 'react'

import { PlanSlug, AddonSlug } from 'common/planSlugs'
import RegisteredOfficeIcon from 'components/icons/RegisteredOfficeIcon'
import DirectorsServiceIcon from 'components/icons/DirectorsServiceIcon'
import MailForwardIcon from 'components/icons/MailForwardIcon'
import WhatsAppIcon from 'components/icons/WhatsAppIcon'

type IconConfig = {
  component: FC<{ fill?: string; width?: number | string; height?: number | string }>
  background: string
}

const iconMap: Record<string, IconConfig> = {
  [PlanSlug.SCAN_LITE]: { component: RegisteredOfficeIcon, background: '#E42692' },
  [PlanSlug.SCAN_PRO]: { component: MailForwardIcon, background: '#3E2155' },
  [PlanSlug.PHONE]: { component: WhatsAppIcon, background: '#46DB52' },
  [AddonSlug.VIRTUAL_OFFICE_PHONE]: { component: WhatsAppIcon, background: '#46DB52' },
  [AddonSlug.DIRECTORS_SERVICE_ADDRESS]: { component: DirectorsServiceIcon, background: '#3EB8E5' },
}

type ProductIconProps = {
  slug: string
  size?: number
  iconFill?: string
  className?: string
  disableBackground?: boolean
}

const ProductIcon: FC<ProductIconProps> = ({
  slug,
  size = 88,
  iconFill = 'white',
  className,
  disableBackground,
}) => {
  const config = iconMap[slug]
  if (!config) return null

  const { component: IconComponent, background } = config

  if (disableBackground) {
    return (
      <IconComponent
        fill={iconFill}
        width={size}
        height={size}
        className={className}
      />
    )
  }

  const iconSize = Math.round(size * 0.55)

  return (
    <div
      className={`d-flex align-items-center justify-content-center flex-shrink-0 ${className || ''}`}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.2),
        backgroundColor: background,
      }}
    >
      <IconComponent
        fill={iconFill}
        width={iconSize}
        height={iconSize}
      />
    </div>
  )
}

export default ProductIcon
